module.exports = __webpack_public_path__ + "static/media/05_custom_power_supply_cable.84e03e2b.jpg";